// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { CommonValues } from "@app/cp/shared/static/CommonValues";


let tempEnvironment = {
    production: false,
    devOrStaging: true,

    APICEndPoint: "http://dev.fieldjetx.com/FJXConnector/apic/",

    /**
     * This is the API end point for calling the FieldJetX microservice API. Most of the calls using this are related to search
     */
    APIEndPoint_v2: "https://api-dev.fieldjetx.com/api/v1/",
    /**
     * This is the main API end point for calling the FieldJetXn2.2 API.
     */
    APIEndPoint: "https://dev.fieldjetx.com/fjxapi/api/",
    APIEndPointRefData: "https://dev.fieldjetx.com/fjxapi/api/",

    /**
     * This is the API end point for the external API. This is for routes that allow anonymous access
     */
    APIEndPointExternal: "https://dev.fieldjetx.com/fjxapi/api/external/",
    APIEndPointSignalR: "https://dev.fieldjetx.com/fjxapi/notify",
    FieldInvoice: "https://staging.fieldjetx.com/FieldJetXM/invoice.aspx?FieldInvoiceQueueId=",
    /**
     * This is the URL for opening a new tab with the expense maintenance application
     */
    AppUrlExpenseMaint: "https://expensemaintenance-dev.fieldjetx.com/",
    VersionRoute: "/version.txt",
    EnableVersionCheck: true,
    VersionCheckInterval: 60000, // 1 minute
    firebase: {},

    debug: true,
    log: {
        auth: false,
        store: false,
    },

    deployment: 'dev',
    appCode: 'FG2',

    releaseVersion: require('../../package.json').version,

    //This is only used in the akita Guard
    smartadmin: {
        api: null,
        db: 'smartadmin-angular'
    },
    useAuthMock: false,
    authConfig: {
        "credentials": {
            "clientId": "e28e432e-fd03-40bf-a7d8-7157178ec56f",
            "tenantId": "522b35a5-68e2-4f5a-81dd-6ce68592d974"
        },
        "configuration": {
            redirectUri: window.location.origin + "/auth/msal",
            postLogoutRedirectUri: window.location.origin + "/login"
        },
        "resources": {
            "apiScopes": ["api://5e763b8e-bd8a-44e0-a308-da2e335f7ff4/FJX_API_Dev"]
        },
        "routes": [
            "*" //we set an empty cause it joins with the baseApiUrl
        ]
    }
};

// Define the expected shape of the environment
interface LocalEnvironment {
    environment: { [key: string]: any; }; // Adjust this type based on your actual environment structure
}

// Create a function to import the local environment
function loadLocalEnvironment() {
    try {
        const localEnv: LocalEnvironment = require('./environment.local.json');
        Object.assign(tempEnvironment, localEnv);
        console.log('%c !! Using Local environment configuration !!', CommonValues.LoggingMessage_ColorOrange);
    } catch (err) {
        console.log('%c !! Local environment configuration not found, using default environment !!', CommonValues.LoggingMessage_ColorOrange);
    }
}
loadLocalEnvironment();

export const environment = { ...tempEnvironment };
